export default {
  getDataUpload: state =>  {
    return state.data
  },
}